import React, { useEffect, useState } from "react";
import CustomIcons from "../../../components/icons/kIcons.component";
import Loader from "../../../components/loader/loader";
import "./style.css";
import { institutionList, vendorDirectoryList } from "../user.api";
import MoreDetailsVendors from "./moreDetailsVendors";
import TextField from "../../../components/inputs/textfield";
import SearchButton from "../../../components/buttons/search/search-btn";
import BreadCrumpBack from "../../../components/navigator/back";

export default function VendorList(props) {
  const [isActive, setIsActive] = useState(false);
  const [data, setData] = useState([]);
  // const [dearchData, setSearchData] = useState([]);
  const [openView, setOpenView] = useState(false);
  const [activeData, setActiveData] = useState({});
  const [selectedExpId, setSelectedExpId] = useState("");
  const [searchData, setSearchData] = useState("");

  const servInstance = process.env.REACT_APP_BASE_URL;
  let result = servInstance.substring(0, servInstance?.length - 4);

  const getData = (search = "") => {
    console.log(search);
    setIsActive(true);
    vendorDirectoryList(search)
      .then((res) => {
        setData(res);
        setSearchData(res);
        setIsActive(false);
      })
      .catch(() => {
        setIsActive(false);
      });
  };

  useEffect(() => {
    getData();
  }, []);
  const handleViewDetails = (item) => {
    setOpenView(true);
    setActiveData(item);
  };
  const handleViewClose = () => {
    setOpenView(false);
    setActiveData({});
  };
  const handleExpertiseChange = (e) => {
    const keyword = e.target.value;
    setSelectedExpId(keyword);
  };
  // const manageStatus = (e) => {
  //   const { name, value } = e.target;
  //   setSearchData(value);
  // };

  const handleSearch = () => {
    const searchData = selectedExpId;
    // if (searchData) {
    const filtered = data.filter((item) =>
      item.area_of_operation.toLowerCase().includes(selectedExpId.toLowerCase())
    );
    setSearchData(filtered);
  };
  const handleClear = () => {
    setSelectedExpId("");
    getData();
  };
  return (
    <div className="proj">
      <Loader open={isActive} />

      <div>
        <div className="dash-banner ">
          <div className="tit-txt">
            {props.state.language === "ma"
              ? "രജിസ്റ്റർ ചെയ്ത സ്ഥാപനങ്ങളുടെ ഡയറക്ടറി"
              : "Directory of Vendors"}
          </div>
        </div>
        <BreadCrumpBack />
        <br />
      </div>
      <div className="container bodybox mt-3">
        <div className="vendor-search-bar d-flex flex-wrap align-items-center mb-4">
          <div className="flex-grow-1">
            <TextField
              type="text"
              className="form-control search-input"
              placeholder="🔍 Search by Area of Operation / Expertise"
              value={selectedExpId}
              onChange={handleExpertiseChange}
            />
          </div>
          <div className="d-flex align-items-center gap-2 ms-3 mt-md-0 mb-3">
            <SearchButton {...props} onClick={handleSearch}>
              Search
            </SearchButton>
            <span className="clearSearchVendor" onClick={handleClear}>
              ✖ Clear
            </span>
          </div>
        </div>

        <div className="row">
          {searchData && (
            <>
              {searchData?.length !== 0 ? (
                <>
                  {searchData?.map((item) => (
                    <div key={item.id} className="col-lg-6 col-sm-12 mb-4">
                      <div className="vendor-card">
                        {/* Logo */}
                        <div
                          className="vendor-logo"
                          style={
                            item.logo
                              ? {
                                  backgroundImage: `url(${result}/${item.logo})`,
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                }
                              : { backgroundColor: "#0a223d", color: "#fff" }
                          }
                        >
                          {!item.logo && item.company_name?.[0]?.toUpperCase()}
                        </div>

                        {/* Company Info */}
                        <h5 className="vendor-title">{item.company_name}</h5>
                        <div className="vendor-section">
                          <div className="vendor-tag">Area of Operation</div>
                          <p className="vendor-area">
                            {item.area_of_operation}
                          </p>
                        </div>

                        {/* Description with Expand */}
                        <p className="vendor-description">
                          {item.showFull
                            ? item.company_description
                            : item.company_description?.slice(0, 100)}
                          {item.company_description?.length > 100 && (
                            <span
                              className="read-more"
                              onClick={() => {
                                const updated = searchData.map((v) =>
                                  v.id === item.id
                                    ? { ...v, showFull: !v.showFull }
                                    : v
                                );
                                setSearchData(updated);
                              }}
                            >
                              {item.showFull ? " Show Less" : " ...Read More"}
                            </span>
                          )}
                        </p>

                        {/* Brochure */}
                        {item.brochure && (
                          <a
                            href={`${result}/${item.brochure}`}
                            target="_blank"
                            rel="noreferrer"
                            className="btn btn-outline-primary brochure-btn"
                          >
                            📄 Download Brochure
                          </a>
                        )}

                        {/* Contact Details */}
                        <div className="vendor-contact">
                          <div className="contact-tag">
                            <strong>Name:</strong> {item.name}
                          </div>
                          <div className="contact-tag">📞 {item.phone}</div>
                          <div className="contact-tag">📧 {item.email}</div>
                        </div>
                      </div>
                    </div>
                  ))}
                </>
              ) : (
                <div className="no-data text-center">
                  <img src="resources/img/no1.png" alt="" />
                  <h4>No Records Found..!!</h4>
                </div>
              )}
            </>
          )}
        </div>
      </div>
      <MoreDetailsVendors
        open={openView}
        data={activeData}
        handleClose={handleViewClose}
        india={props?.india}
      />
    </div>
  );
}
